import { Component, OnInit, ViewChild } from '@angular/core';
import { Ingreso } from 'src/app/model/index.model';
import { IngresoService } from 'src/app/service/index.service';
import { Router } from '@angular/router';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import Swal from 'sweetalert2';
import { FilIngresoComponent } from '../../filtro/fil-ingreso/fil-ingreso.component';

@Component({
  selector: 'app-lst-ingreso',
  templateUrl: './lst-ingreso.component.html',
  styleUrls: ['./lst-ingreso.component.css']
})
export class LstIngresoComponent implements OnInit {


  @ViewChild(FilIngresoComponent, { static: true }) fil: FilIngresoComponent;
  entity = "Ingresos"

  items: Ingreso[];
  item: Ingreso;

  proccess: Boolean;

  constructor(private wsdl: IngresoService, private router: Router) {
    this.item = new Ingreso();
  }

  ngOnInit() {
    this.fil.list()

  }

  preNew() {
    this.item = new Ingreso();
  }

  select(item: Ingreso) {
    this.item = item;
  }

  cancel() {
    this.item = new Ingreso();
    this.fil.list();
  }

  async setResultCancel(event: boolean) {
    UturuncoUtils.showToas("Operación cancelada", "info");
  }

  setResult(event: any) {
    this.cancel();
  }

  preDelete(item: Ingreso) {
    this.item = new Ingreso();
    this.item = item;

    Swal.fire({
      title: 'Esta Seguro?',
      text: '¡No podrás recuperar este archivo ' + item.nroFactura + '!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '¡Sí, bórralo!',
      cancelButtonText: 'No, mantenlo',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.value) {
        this.delete()
      } else if (result.dismiss === Swal.DismissReason.cancel) {

        UturuncoUtils.showToas('Tu archivo esta seguro :)', "warning")

      }
    })
  }

  async delete() {
    try {
      this.proccess = true;
      const res = await this.wsdl.doDelete(this.item.id).then();
      const result = JSON.parse(JSON.stringify(res));
      if (result.code == 200) {
        UturuncoUtils.showToas(result.msg, "success");
        this.cancel();
      } else {
        UturuncoUtils.showToas(result.msg, "error");
      }
    } catch (error) {
      UturuncoUtils.showToas("Excepción: " + error.message, "error");
    }
    this.proccess = false;
  }

  doFound(event: Ingreso[]) {
    this.items = event;
  }

  linkear(id?: number) {
    this.router.navigateByUrl("admin/" + this.entity.toLocaleLowerCase() + "/abm/" + id);
  }

  gestionar(id?: number) {
    this.router.navigateByUrl("admin/detalleIngresos/gst/" + id);

  }

  view(item) {
    item = JSON.parse(item)
    return item.proveedor ? item.proveedor + " " + item.expediente : "";
  }

}
